<template>
    <div class="leftMenu">
      <el-menu
        :default-active="index"
        class="el-menu-vertical-demo"
        router>
        <el-menu-item index="1" :route="$route.path.slice(1,4)=='web'?'/webinfo':($route.path.slice(1,4)=='uni'?'/unityinfo':'other1')">
          <i class="el-icon-postcard"></i>
          <span v-if="$route.path.slice(1,4)!='oth'" slot="title">简历</span>
          <span v-if="$route.path.slice(1,4)=='oth'" slot="title">手写富文本</span>
        </el-menu-item>
        <el-menu-item  index="2" :route="$route.path.slice(1,4)=='web'?'/webshare':($route.path.slice(1,4)=='uni'?'/unityshare':'other2')">
          <i v-if="$route.path.slice(1,4)!='oth'" class="el-icon-magic-stick"></i>
          <span v-if="$route.path.slice(1,4)!='oth'" slot="title">技术分享</span>
          <i v-if="$route.path.slice(1,4)=='oth'" class="el-icon-magic-stick"></i>
          <span v-if="$route.path.slice(1,4)=='oth'" slot="title">ECharts天气预报</span>
        </el-menu-item>
        <el-menu-item v-if="$route.path.slice(1,4)=='uni'" index="3" route="/unitygame">
          <i class="el-icon-wallet" route="/unitygame"></i>
          <span slot="title">作品展示</span>
        </el-menu-item>
      </el-menu>
    </div>
</template>

<script>

export default {
  data() {
    return {
      index:"1",
    }
  },
  methods:{

  },
  watch:{
    $route(to,from){
      
      if(to.path.slice(-2)=="fo" || to.path.slice(-2)=="r1"){
        this.index="1"
      }
      else if(to.path.slice(-2)=="re" || to.path.slice(-2)=="r2"){
        this.index="2"
      }
      else if(to.path.slice(-2)=="me"){
        this.index="3"
      }
      
    }
}
}
</script>

<style>

</style>